import template from './messageEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      eventService,
      messageService,
      mergeFieldsService,
      uiService,
      Message,
      MessageType
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.destroyWatch = eventService.onMessageEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                message: params.message ? angular.copy(params.message) : Message.blank(),
                mergeFields: params.mergeFields,
                currentOrganization: $rootScope.CurrentOrganization
              },
              template,
              controllerAs: '$ctrl',
              controller(scope, message, mergeFields, currentOrganization) {
                const ctr = this;
                ctr.organization = currentOrganization;
                ctr.message = message;
                ctr.isEditingMessage = _.isUuid(message.id);
                ctr.mergeFields = mergeFields;
                ctr.mergeValues = {
                  'contact1.entity': 'Person',
                  'contact1.nameFirst': 'John',
                  'contact1.nameFamily': 'Doe',
                  'contact1.nameFull': 'John Doe',
                  'contact1.nameCompany': 'John Doe',
                  'contact1.notes': 'Notes',
                  'contact1.eMail': 'john@doe.mail',
                  'contact1.primaryPhone': '+61 04 1234 5678',
                  'contact1.spouseName': 'Johanna',
                  'contact1.currentAddress': '1 Address Street, Sydney NSW 2000'
                };

                ctr.messageTypes = _.filter(
                  MessageType.available(),
                  (m) => m.name === MessageType.email.name || m.name === MessageType.sms.name
                );

                ctr.disableToggleType = (type) => {
                  const idx = _.findIndex(
                    ctr.message.type,
                    (t) => MessageType.of(t?.name || t).name === type.name
                  );
                  const oneSelected = ctr.message.type.length === 1;
                  return oneSelected && idx > -1;
                };

                ctr.toggleType = (type) => {
                  const idx = _.findIndex(
                    ctr.message.type,
                    (t) => MessageType.of(t?.name || t).name === type.name
                  );
                  if (idx > -1) {
                    ctr.message.type.splice(idx, 1);
                  } else {
                    ctr.message.type.push(type);
                  }
                };

                ctr.merge = (text, values) => {
                  let output = text;
                  const mergeKeys = ctr.getMergeKeys(text);
                  if (mergeKeys && mergeKeys.length) {
                    const len = mergeKeys.length;
                    for (let i = 0; i < len; i += 1) {
                      output = output.replace(
                        new RegExp(`{${mergeKeys[len]}}`, 'g'),
                        values[mergeKeys[len]] !== undefined ? values[mergeKeys[len]] : ''
                      );
                    }
                  }
                  return output;
                };

                ctr.decodeURIParameter = (s) => decodeURIComponent(s.replace(/\+/g, ' '));

                ctr.getMergeKeys = (text) => {
                  const regex = /{([^}]+)}/g;
                  const codes = [];
                  let code = regex.exec(text);
                  while (code !== null) {
                    const p = ctr.decodeURIParameter(code[1]);
                    if (p === text) {
                      codes.push(code[1]);
                    }
                    code = regex.exec(text);
                  }
                  return codes;
                };

                ctr.addPropertyCode = (binding, property) => {
                  eventService.inputInsertValue(binding, `{${property.key}}`);
                };

                ctr.confirm = () => {
                  ctr.isProcessing = true;
                  if (ctr.message.name !== '') {
                    ctr.isProcessing = false;
                    $mdDialog.hide(ctr.message);
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Notification',
                        p2: 'name',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };

                ctr.cancel = () => {
                  $mdDialog.cancel();
                };

                if (_.isEmpty(ctr.message.type)) {
                  ctr.toggleType(_.head(ctr.messageTypes));
                }
              }
            })
            .then((result) => {
              const message = result;
              if (!_.isUuid(message.id)) {
                messageService.createMessage(message).then((data) => {
                  if (data.status) {
                    message.id = data.id;
                    message.isNew = true;
                    ctrl.onFinished({ message });
                    uiService.toast({
                      text: {
                        p1: 'Notification',
                        p2: message.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                messageService.updateMessage(message).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ message });
                    uiService.toast({
                      text: {
                        p1: 'Notification',
                        p2: message.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
